import { t } from 'i18next';
import { AllocationHeadCell } from './types';

export const allocationsHeadCells: AllocationHeadCell[] = [
  {
    id: 'job',
    numeric: false,
    label: t('job', { ns: 'job' }),
    align: 'left',
  },
  {
    id: 'counterparty',
    numeric: true,
    label: t('counterparty', { ns: 'counterparty' }),
    align: 'left',
  },
  {
    id: 'jobAmount',
    numeric: true,
    label: t('allocationAmount', { ns: 'invoice' }),
    align: 'right',
  },
  {
    id: 'creationDate',
    numeric: true,
    label: t('date', { ns: 'misc' }),
    align: 'left',
  },
  {
    id: 'status',
    numeric: true,
    label: t('invoice.status.label', { ns: 'reports' }),
    align: 'justify',
  },
];

export const allocationStatus = {
  PENDING: t('allocationStatus.PENDING', { ns: 'invoice' }),
  ACCEPTED: t('allocationStatus.ACCEPTED', { ns: 'invoice' }),
  REJECTED: t('allocationStatus.REJECTED', { ns: 'invoice' }),
  REQUIRES_CORRECTION: t('allocationStatus.REQUIRES_CORRECTION', {
    ns: 'invoice',
  }),
};
